import { Tooltip } from "antd";
import React from "react";

import PublishBookedContractDurationIcon from "@/Components/Icons/PublishBookedContractDurationIcon";

import useRealTimerForUpcomingBooking from "../../../../utilities/hooks/useRealTimerForUpcomingBooking";

const LiverTImerForUpcomingShifts = ({
  contractDate,
  contractStartTime,
  cls = "text-yellow",
}) => {
  // console.log("contractDate", contractDate);
  const statusMessage = useRealTimerForUpcomingBooking(
    contractDate,
    contractStartTime,
  );

  // Parse the statusMessage to get the time in HH:mm:ss format
  const parseTimeToHHMMSS = (statusMessage) => {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;

    if (
      statusMessage.includes("Shift starts in") ||
      statusMessage.includes("Candidate late by")
    ) {
      // Remove the text part and sanitize the message
      const timeString = statusMessage
        .replace("Candidate late by ", "")
        .replace("Shift starts in ", "")
        .replace(" hour", ":")
        .replace(" minutes", ":")
        .replace(" minute", ":")
        .replace(" second", "")
        .replace(" seconds", "")
        .replace("s", "")
        .replace(" s", "");

      // Now we split the time string and assign the hours, minutes, and seconds
      const timeParts = timeString.split(":");

      // Handle different time formats
      if (timeParts.length === 3) {
        hours = parseInt(timeParts[0], 10) || 0;
        minutes = parseInt(timeParts[1], 10) || 0;
        seconds = parseInt(timeParts[2], 10) || 0;
      } else if (timeParts.length === 2) {
        // Case where only minutes and seconds are present
        minutes = parseInt(timeParts[0], 10) || 0;
        seconds = parseInt(timeParts[1], 10) || 0;
      } else if (timeParts.length === 1) {
        // Case where only seconds are present
        seconds = parseInt(timeParts[0], 10) || 0;
      }
    }

    // Return the formatted time as HH:mm:ss
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  const formattedTime = parseTimeToHHMMSS(statusMessage);

  return (
    <Tooltip title={statusMessage}>
      <button className="flex items-center gap-1">
        <PublishBookedContractDurationIcon cls={cls} />
        <span className="text-sm font-semibold text-txtColor text-yellow-900">
          {formattedTime}
        </span>
      </button>
    </Tooltip>
  );
};

export default LiverTImerForUpcomingShifts;
